var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-mdl2:market",
    clipPath: "url(#clip0_859_4071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5972 3.7426V9.05175H16.5354V5.55932L10.1644 11.9303L6.9789 8.74481L1.37941 14.336L0.632812 13.5894L6.9789 7.23502L10.1644 10.4205L15.7805 4.80443H12.2881V3.7426H17.5972Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_4071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9893,
    height: 16.9893,
    fill: "white",
    transform: "translate(0.607925 0.55711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsMarketing);
export default __webpack_public_path__ + "static/media/settings-marketing.fce4d114d6a42382a075f6e28cc134cf.svg";
export { ForwardRef as ReactComponent };